import moment from "moment";
import MenuItem from "@mui/material/MenuItem";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListSubheader from "@mui/material/ListSubheader";
import Icon from "@mdi/react";
import { mdiRefresh } from "@mdi/js";
import { useQueryVoteResult } from "../../hooks/top14ApiHooks";
import { useAppStore } from "../../store/appStore";

const LastRefreshTime = () => {
	const sortEnabled = useAppStore((state) => state.sortEnabled);
	const listOption = useAppStore((state) => state.listOption);

	const { refetch, data } = useQueryVoteResult({
		listOption,
		sortEnabled,
	});

	const refresh = () => {
		refetch();
	};

	return (
		<List subheader={<ListSubheader>資料最後更新時間</ListSubheader>}>
			<ListItem dense>
				<ListItemText>
					{Boolean(data?.lastRefreshTime)
						? moment(data?.lastRefreshTime).format("DD MMM YYYY")
						: "-"}
				</ListItemText>
				<ListItemText>
					{Boolean(data?.lastRefreshTime) &&
						moment(data?.lastRefreshTime).format("HH:mm")}
				</ListItemText>
			</ListItem>
			<MenuItem onClick={refresh}>
				<ListItemIcon>
					<Icon size={1} path={mdiRefresh} />
				</ListItemIcon>
				<ListItemText>重新整理</ListItemText>
			</MenuItem>
		</List>
	);
};

export default LastRefreshTime;
